import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';
import { CustomizedTooltipProps } from './types';

const useStyles = makeStyles<Theme, CustomizedTooltipProps>((theme) => ({
  arrow: {
    '&::before': {
      boxShadow: (props) => {
        if (props.variant === 'paper') {
          return '0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.07), 0px 3px 14px 2px rgba(0, 0, 0, 0.06)';
        }
        return '';
      },
      backgroundColor: (props) => {
        if (props.variant === 'paper') {
          return '#fff';
        }
        // tooltip arrow styles
        return props.backgroundcolor ?? colorSet.gray800;
      }
    }
  },
  tooltip: {
    zIndex: (props) => (props.zIndex ? props.zIndex : 500),
    margin: (props) => (props.gutter ? props.gutter : '14px 0px'),
    borderRadius: 8,
    minWidth: (props) => (props.minWidth ? props.minWidth : ''),
    maxWidth: (props) => (props.maxWidth ? props.maxWidth : ''),
    padding: (props) => {
      if (props.variant === 'paper') {
        return 0;
      }
      return '10px 16px';
    },
    color: (props) => {
      if (props.variant === 'paper') {
        return colorSet.gray900;
      }
      return '#fff';
    },
    backgroundColor: (props) => {
      if (props.variant === 'paper') {
        return '#fff';
      }

      return props.backgroundcolor ?? colorSet.gray800;
    },
    boxShadow: (props) => {
      if (props.variant === 'paper') {
        return '0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.07), 0px 3px 14px 2px rgba(0, 0, 0, 0.06)';
      }
      return '';
    },
    '& .title': {
      ...theme.typography.body2,
      fontWeight: 500,
      color: colorSet.gray000
    },
    '& p': {
      wordBreak: 'break-all'
    }
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    padding: 10,
    color: colorSet.gray000,
    transform: (props) =>
      props.variant === 'paper' ? 'translateY(0px)' : 'translateY(-8px)'
  },
  tooltipPlacementBottom: {
    // top: 8
  },
  tooltipPlacementTop: {
    top: '-24px'
  },
  popper: {
    zIndex: (props) => (props.zIndex ? props.zIndex : 500),
    pointerEvents: (props) => (props.open ? 'auto' : 'none')
  }
}));

export default useStyles;
